import fetch from 'cross-fetch'

export const checkStatusCode = async (response, url) => {
  if (response.status >= 200 && response.status < 400) {
    return response
  }

  const contentType = response.headers.get('content-type')
  if (contentType && contentType.includes('application/json')) {
    const { error } = await response.json()

    const exception = new Error()
    if (typeof error === 'string') {
      exception.message = error
    } else {
      exception.message = error.title
      if (error.detail) {
        exception.message += `: ${error.detail}`
      }
      if (error.httpStatus) {
        exception.status = parseInt(error.httpStatus)
      }
    }

    console.log(`Request to '${url}' returned an error`)
    throw exception
  }

  console.log(`Request to '${url}' returned an error`)
  throw new Error(response.status)
}

export const makeRequest = async ({ url, requestOptions }) => {
  let response = await fetch(url, { ...requestOptions, keepalive: true })

  response = await checkStatusCode(response, url)
  const contentType = response.headers.get('content-type')

  if (contentType && contentType.includes('application/json')) {
    return response.json()
  }
  return {}
}
